import { render, staticRenderFns } from "./faultDictionary.vue?vue&type=template&id=96d51ac0&scoped=true"
import script from "./faultDictionary.vue?vue&type=script&lang=js"
export * from "./faultDictionary.vue?vue&type=script&lang=js"
import style0 from "./faultDictionary.vue?vue&type=style&index=0&id=96d51ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d51ac0",
  null
  
)

export default component.exports